import { render, staticRenderFns } from "./RelatorioNotificacoes.vue?vue&type=template&id=c3c76234&"
import script from "./RelatorioNotificacoes.vue?vue&type=script&lang=js&"
export * from "./RelatorioNotificacoes.vue?vue&type=script&lang=js&"
import style0 from "./RelatorioNotificacoes.vue?vue&type=style&index=0&id=c3c76234&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports